/**
 * Created by Languagenut on 22/03/2019.
 */


import React  from 'react';
import {Alert , Form  , Card , Row , Col , Button} from 'react-bootstrap'
import {SectionMenu} from '../components';
import ReactDOM from "react-dom";

class CSVInput extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    handleChange(e){
        var file = ReactDOM.findDOMNode(this.refs.csv).files[0];
        if(!file)
            return;

        this.props.handleFileChange(file);
    }

    render() {
        return (
            <Row>
                <form className="form-inline">
                    <div className="form-group">
                        <label htmlFor="file">Select CSV File</label>&nbsp;&nbsp;&nbsp;
                        <input type="file" className="form-control" id="file" accept=".csv" onChange={this.handleChange.bind(this)} ref="csv" />
                    </div>
                </form>
            </Row>
        );
    }
};

export default class Account extends React.Component {


    constructor(props) {
        super();
        this.props = props;
        this.state = {
            cols :[{},{},{},{}],
            fields:[
                {name:"---- Don't map this field ----" , id:""},
                {name:"ID" , id:""},
                {name:"First Name" , id:""},
                {name:"Last Name" , id:""},
                {name:"Class Name" , id:""},
                {name:"Year Group" , id:""},
                {name:"Username" , id:""},
                {name:"Password" , id:""},
            ]
        };
    }


    handleFileChange(){

    }

    renderRows(){
        let rows = [];

        for(var idx = 0; idx < this.state.cols.length; idx++)
        {

            let fields = [];
            for(var jdx = 0 ; jdx < this.state.fields.length; jdx++)
            {
                fields.push(<option>{this.state.fields[jdx].name}</option>)
            }


            rows.push(<Row>
                <Col md={6}>rr</Col>
                        <Col md={6}><Form.Control as="select">
                            {fields}
                        </Form.Control></Col>

            </Row>);

            rows.push(<br/>)
        }

        return rows;
    }

    render(){




        return <div style={{paddingTop:"20px"}} >
                <Row>
                    <Col sm={2} md={3}>
                        <SectionMenu />
                    </Col>
                    <Col sm={10} md={9}>
                        <Card>
                            <Card.Body>
                                <Row>
                                    <Col md={12}>
                                        <h4>Information</h4>
                                        <p>Match your coloums to the relvent fields , The importer will generate a username and password if left blank classes will also me created and students allocated to the group/class</p>
                                    </Col>
                                </Row>
                                {this.renderRows.bind(this)()}
                                <Button>Add Field</Button>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
        </div>
    }


}